module.exports = __webpack_public_path__ + "assets/headspace_logo@2x-c8aaf1b6f0a2f58b4dcc12362d8fa771.png";